import { render, staticRenderFns } from "./FormButtonBar.vue?vue&type=template&id=33fd16b1&"
import script from "./FormButtonBar.vue?vue&type=script&lang=js&"
export * from "./FormButtonBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports